<div class="wrapper bg-area" *ngIf="!isMobile">
  <section id="pagamento-debito">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6">
          <h3 class="title">Monte seu Plano</h3>
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li class="active">Pagamento</li>
              <li>Segurança</li>
              <li>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <div class="body-faca-parte columns">
          <div class="column is-6">

            <form class="dados-pessoais" [formGroup]="form">

              <h4>DADOS DE PAGAMENTO</h4>
              <p>Agora, seus Dados de Pagamento</p>

              <div class="metodo-credito">
                <div class="area-card">
                  <img class="icon-cartao-verde icon-verde" src="./assets/img/icon-carteira.png">
                </div>

                <p class="opcao-pagamento">
                  <strong>DÉBITO EM CONTA</strong>
                  <br>
                  <a href="/pagamentos"><small>Trocar método de pagamento</small></a>
                </p>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label for="debitoCodigoBanco">Nome do Banco</label>
                <select formControlName="debitoCodigoBanco"
                        name="debitoCodigoBanco"
                        id="debitoCodigoBanco"
                        required
                        (ngModelChange)="defaultValue()"
                >
                  <option value="" selected>Informe o Banco</option>
                  <option value="001">Banco do Brasil</option>
                  <option value="070">Banco de Brasília</option>
                  <option value="104">Caixa Econômica Federal</option>
                  <option value="237">Bradesco S/A</option>
                  <option value="341">Banco Itaú S.A</option>
                  <option value="356">Banco Real/Santander</option>
                </select>
                <span class="campo-erro"
                  *ngIf="showError('debitoCodigoBanco')">{{getErrorMessage('debitoCodigoBanco')}}</span>
              </div>
              <div class="field control-input novo-cliente" tabindex="2">
                <label>Agência</label>
                <input formControlName="debitoAgencia"
                       [class]="fieldCssClass(form, 'debitoAgencia')"
                       (ngModelChange)="isAgenciaValid($event)"
                       mask="{{maskDigitoAgencia ? maskDigitoAgencia : '9999-9'}}"
                       name="debitoAgencia" type="text"
                       placeholder="Agência"
                       mask-output="alphanumeric"
                       minlength="{{minLengthAgencia ? minLengthAgencia : 4}}"
                       maxlength="{{maxLengthAgencia ? maxLengthAgencia : 4}}"
                       required>
                <span class="campo-erro" *ngIf="showError('debitoAgencia')">{{getErrorMessage('debitoAgencia')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="2">
                <label>Conta</label>
                <input formControlName="debitoContaCorrente"
                       (ngModelChange)="isContaValid($event)"
                       [class]="fieldCssClass(form, 'debitoContaCorrente')"
                       mask="{{maskDigitoConta ? maskDigitoConta : '99999999999999'}}"
                       name="debitoContaCorrente"
                       type="text"
                       placeholder="Conta"
                       mask-output="alphanumeric"
                       minlength="{{minLengthConta ? minLengthConta : 7}}"
                       maxlength="{{maxLengthConta ? maxLengthConta : 12}}"
                       required>
                <span class="campo-erro"
                  *ngIf="showError('debitoContaCorrente')">{{getErrorMessage('debitoContaCorrente')}}</span>
              </div>

              <p class="opcao-cobranca"><strong>DIA DO DÉBITO</strong></p>

              <div class="radio-selector">
                <label class="radio-input">
                  <input formControlName="debitoDataPagamento" type="radio" value="08">
                  <span class="checkmark">08</span>
                </label>

                <label class="radio-input">
                  <input formControlName="debitoDataPagamento" type="radio" value="20">
                  <span class="checkmark">20</span>
                </label>

                <label class="radio-input">
                  <input formControlName="debitoDataPagamento" type="radio" value="30">
                  <span class="checkmark">30</span>
                </label>
              </div>
              <div>
                <span class="campo-erro"
                  *ngIf="showError('debitoContaCorrente')">{{getErrorMessage('debitoContaCorrente')}}</span>
              </div>

              <p class="opcao-cobranca"><strong>ENDEREÇO DE COBRANÇA</strong></p>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>CEP</label>
                <input formControlName="cep" [class]="fieldCssClass(form, 'cep')" (focusout)="buscarCep($event, form)"
                  name="cep" type="text" placeholder="CEP" mask="00000-000" mask-output="alphanumeric" required>
                <span class="campo-erro" *ngIf="showError('cep')">{{getErrorMessage('cep')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Endereço</label>
                <input formControlName="logradouro" [class]="fieldCssClass(form, 'logradouro')" name="endereco"
                  type="text" placeholder="Endereço" required>
                <span class="campo-erro" *ngIf="showError('logradouro')">{{getErrorMessage('logradouro')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Número</label>
                <input formControlName="numero" [class]="fieldCssClass(form, 'numero')" name="numero" type="text"
                  placeholder="Número">
                <span class="campo-erro" *ngIf="showError('numero')">{{getErrorMessage('numero')}}</span>
              </div>

              <div class="field control-input novo-cliente" tabindex="1">
                <label>Complemento</label>
                <input formControlName="complemento" [class]="fieldCssClass(form, 'complemento')" name="complemento"
                  type="text" placeholder="Complemento">
                <span class="campo-erro" *ngIf="showError('complemento')">{{getErrorMessage('complemento')}}</span>
              </div>

              <app-termo-uso
                      (termoDeUsoAceitoEmit)="termoDeUsoAceitoEmit($event)"
                      [link]="'/como-funciona'"
                      [type]="'pagamento'"></app-termo-uso>

              <span class="voce-seguro">Seus dados só serão utilizados para comunicação entre a Montreal e você e jamais
                serão divulgados a terceiros.</span>

            </form>
          </div>

          <app-resumo [result]="propostaResult" [totalDiarias]="countDiarias">
            <button type="button" (click)="submit()"
                    [disabled]="form.invalid"
                    [class]="form.invalid ? 'btn-desabilitado' : 'btn-verde'">
              CONTINUAR
            </button>
          </app-resumo>
        </div>
      </div>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dadoes e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
<div class="wrapper bg-area" *ngIf="isMobile">
  <section id="pagamento-debito-mobile">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="title">
          <h3>Agora, seus Dados de Pagamento</h3>
        </div>
        <form class="dados-pessoais" [formGroup]="form">
          <div class="metodo-credito">
            <div class="area-card">
              <img class="icon-cartao-verde icon-verde" src="./assets/img/icon-carteira.png">
            </div>
            <p class="opcao-pagamento">
              <strong>DÉBITO EM CONTA</strong>
              <br>
              <a href="/pagamentos"><small>Trocar método de pagamento</small></a>
            </p>
          </div>
          <div class="forms">
            <div class="field control-input novo-cliente" tabindex="1">
              <label for="debitoCodigoBanco-mobile"></label>
              <select formControlName="debitoCodigoBanco"
                      name="debitoCodigoBanco"
                      id="debitoCodigoBanco-mobile"
                      required
                      (ngModelChange)="defaultValue()"
              >
                <option value="" selected>Informe o Banco</option>
                <option value="001">Banco do Brasil</option>
                <option value="070">Banco de Brasília</option>
                <option value="104">Caixa Econômica Federal</option>
                <option value="237">Bradesco S/A</option>
                <option value="341">Banco Itaú S.A</option>
                <option value="356">Banco Real/Santander</option>
              </select>
              <span class="campo-erro"
                    *ngIf="showError('debitoCodigoBanco')">{{getErrorMessage('debitoCodigoBanco')}}</span>
            </div>
            <div class="field control-input novo-cliente" tabindex="2">
              <label></label>
              <input formControlName="debitoAgencia"
                     [class]="fieldCssClass(form, 'debitoAgencia')"
                     (ngModelChange)="isAgenciaValid($event)"
                     mask="{{maskDigitoAgencia ? maskDigitoAgencia : '9999-9'}}"
                     name="debitoAgencia" type="text"
                     placeholder="Agência"
                     mask-output="alphanumeric"
                     minlength="{{minLengthAgencia ? minLengthAgencia : 4}}"
                     maxlength="{{maxLengthAgencia ? maxLengthAgencia : 4}}"
                     required>
              <span class="campo-erro" *ngIf="showError('debitoAgencia')">{{getErrorMessage('debitoAgencia')}}</span>
            </div>
            <div class="field control-input novo-cliente" tabindex="2">
              <input formControlName="debitoContaCorrente"
                     (ngModelChange)="isContaValid($event)"
                     [class]="fieldCssClass(form, 'debitoContaCorrente')"
                     mask="{{maskDigitoConta ? maskDigitoConta : '99999999999999'}}"
                     name="debitoContaCorrente"
                     type="text"
                     placeholder="Conta"
                     mask-output="alphanumeric"
                     minlength="{{minLengthConta ? minLengthConta : 7}}"
                     maxlength="{{maxLengthConta ? maxLengthConta : 12}}"
                     required>
              <span class="campo-erro"
                    *ngIf="showError('debitoContaCorrente')">{{getErrorMessage('debitoContaCorrente')}}</span>
            </div>

            <p class="opcao-cobranca"><strong>DIA DO DÉBITO</strong></p>
            <div class="radio-selector">
              <label class="radio-input">
                <input formControlName="debitoDataPagamento" type="radio" value="08">
                <span class="checkmark">08</span>
              </label>

              <label class="radio-input">
                <input formControlName="debitoDataPagamento" type="radio" value="20">
                <span class="checkmark">20</span>
              </label>

              <label class="radio-input">
                <input formControlName="debitoDataPagamento" type="radio" value="30">
                <span class="checkmark">30</span>
              </label>
            </div>
            <div>
                <span class="campo-erro" *ngIf="showError('debitoContaCorrente')">
                  {{getErrorMessage('debitoContaCorrente')}}
                </span>
            </div>

            <p class="opcao-cobranca"><strong>ENDEREÇO DE COBRANÇA</strong></p>
            <div class="field control-input novo-cliente" tabindex="1">
              <label></label>
              <input formControlName="cep"
                     [class]="fieldCssClass(form, 'cep')"
                     (focusout)="buscarCep($event, form)"
                     name="cep"
                     type="text"
                     placeholder="CEP"
                     mask="00000-000"
                     mask-output="alphanumeric"
                     required>
              <span class="campo-erro" *ngIf="showError('cep')">{{getErrorMessage('cep')}}</span>
            </div>
            <div class="field control-input novo-cliente" tabindex="1">
              <label></label>
              <input formControlName="logradouro"
                     [class]="fieldCssClass(form, 'logradouro')"
                     name="endereco"
                     type="text"
                     placeholder="Endereço"
                     required>
              <span class="campo-erro" *ngIf="showError('logradouro')">{{getErrorMessage('logradouro')}}</span>
            </div>
            <div class="field control-input novo-cliente" tabindex="1">
              <label></label>
              <input formControlName="numero"
                     [class]="fieldCssClass(form, 'numero')"
                     name="numero" type="text"
                     placeholder="Número">
              <span class="campo-erro" *ngIf="showError('numero')">{{getErrorMessage('numero')}}</span>
            </div>
            <div class="field control-input novo-cliente" tabindex="1">
              <label></label>
              <input formControlName="complemento"
                     [class]="fieldCssClass(form, 'complemento')"
                     name="complemento"
                     type="text"
                     placeholder="Complemento">
              <span class="campo-erro" *ngIf="showError('complemento')">{{getErrorMessage('complemento')}}</span>
            </div>
            <app-termo-uso (termoDeUsoAceitoEmit)="termoDeUsoAceitoEmit($event)" [type]="'pagamento'"></app-termo-uso>
            <span class="voce-seguro">
              Seus dados só serão utilizados para comunicação entre a Montreal
              e você e jamais serão divulgados a terceiros.
            </span>
          </div>
          <div class="column is-6 resumo-compra" *ngIf="propostaResult">
            <div class="area-fixed-resumo" *ngIf="isMobile">
              <div class="seu-plano">
                <div class="total">
                  <div *ngIf="isCupomValido != null && isCupomValido && cupom">
                    <h4>
                      <strong>Taxa de adesão</strong>
                    </h4>
                    <p class="valores-cupom">
                      <span>De</span>
                      <span class="line-through">
                        {{propostaResult ? propostaResult.valorAdesao.toString() : '0'}}
                        </span>
                    </p>
                    <p class="valores-cupom vc2">
                      <small>Por</small>
                      <span class="valor-final"> {{propostaResult ? propostaResult.valorAdesaoDesconto.toString() : '0'}}</span>
                    </p>
                  </div>

                  <div *ngIf="!isCupomValido">
                    <h4>
                      <strong>Taxa de adesão</strong>
                    </h4>
                    <p class="valores-cupom">
                      <span></span>
                      <span class="line-through"></span>
                    </p>
                    <p class="valores-cupom vc2">
                      <small></small>
                      <span class="valor-final"> {{propostaResult.valorAdesao.toString()}}</span>
                    </p>
                  </div>

                  <div *ngIf="isCupomValido != null && isCupomValido && cupom">
                    <h4>
                      <strong>Mensalidade</strong>
                    </h4>
                    <p  class="valores-cupom">
                      <span>De</span>
                      <span class="line-through">
                        {{propostaResult && propostaResult.valorMensalidade? propostaResult.valorMensalidade.toString() : '0'}}
                        </span>
                    </p>
                    <p  class="valores-cupom mvc2">
                      <small>Por</small>
                      <span class="valor-final">
                        {{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                        </span>
                    </p>
                  </div>

                  <div *ngIf="!isCupomValido">
                    <p  class="valores-cupom">
                      <strong>Mensalidade</strong>
                      <span></span>
                      <span class="line-through"></span>
                      <small></small>
                      <span class="valor-final">{{propostaResult.valorMensalidade}}</span>
                    </p>
                  </div>

                  <div>
                    <h4>
                      <strong>Valor do Plano</strong>
                    </h4>
                    <p class="valor-plano">
                        <span class="valor">
                      <small></small>
                          {{propostaResult && propostaResult.valorMensalidadeDesconto && propostaResult.valorMensalidadeDesconto.toString() != 'R$ 0,00' ? propostaResult.valorMensalidadeDesconto : propostaResult.valorMensalidade.toString()}}
                          /
                      <span>mês</span>
                      </span>
                    </p>
                  </div>

                  <div class="btn-mobile">
                    <button [disabled]="form.invalid"
                            type="button"
                            [class]="form.invalid ? 'btn-desabilitado' : 'btn-verde'"
                            (click)="submit()"
                            class="btn-verde">
                      CONTINUAR
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>

  <div class="aviso">
    <div class="revise-dados">
      <h3>Olá, Pedro!</h3>
      <a href="" class="link-verde">Não sou o Pedro</a>
      <p>Identificamos pelo seu CPF que você já é um cliente Montreal. Para agilizar sua compra, revise os dadoes e
        confirme efetuando seu login.</p>

      <a href="" class="btn-verde">REVISAR E CONCLUIR</a>
      <a href="" class="link-verde">Preciso atualizar meu cadastro</a>
    </div>
  </div>

</div>
